import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  imagePreview: { maxWidth: 30, verticalAlign: 'middle', marginLeft: 10 },
})

export { useStyles }
